<template>
    <div v-if="showAlert" :class="typeClass" class="panel">
        <div class="panel-heading">
            <i class="fas fa-exclamation-triangle"></i> {{ alert.title }}
        </div>
        <div class="panel-body">
            <p class="m-b-none">{{ alert.msg }}</p>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "AlertBox",
    props: {
        name: {
            type: String,
            require: true,
        },
    },
    computed: {
        showAlert() {
            return this.existAlert(this.name);
        },
        alert() {
            return this.getAlert(this.name);
        },
        typeClass() {
            switch (this.alert.type) {
                case 'error':
                    return 'panel-danger';
                case 'warning':
                    return 'panel-warning';
                default:
                    return '';
            }
        },
        ...mapGetters(["existAlert", "getAlert"]),
    },
};

</script>
